import { AppRouteProps } from "@harea/component";
import React from "react";

const IndemnityListContainer = React.lazy(() => import("./container/IndemnityListContainer"));

export const IndemnityRoutes = [
    {
        path: "indemnities",
        element: <IndemnityListContainer />,
        title: "std_indemnities",
    },
] as Array<AppRouteProps>;